const CONFIG = {
    iterations: 10,
    year: 365,
    minRpsn: -0.00001 / 100,
    maxRpsn: 100000000 / 100,
}

const calculateRPSNLeftSide = (bound, installments) => {
    const base = bound + 1
    return installments.reduce((sum, inst) => {
        const denominator = base ** inst.exponent
        return sum + inst.amount / denominator
    }, 0)
}

const calculateRPSNRightSide = (bound, payments) => {
    const base = bound + 1
    return payments.reduce((sum, payment) => {
        const denominator = base ** payment.exponent
        return sum + payment.amountFee / denominator
    }, 0)
}

// Main function that calculates RPSN (APR) from raw installment and payment data with left and right side of RPSN
export const calculateAPR = (rawInstallments, rawPayments) => {
    //Transformation of data to be able to send raw data
    const installments = rawInstallments.map((inst) => ({
        amount: inst.amount,
        exponent: inst.day / CONFIG.year,
    }))

    const payments = rawPayments.map((p) => ({
        amountFee: p.amount + p.fee,
        exponent: p.day / CONFIG.year,
    }))

    let jump = CONFIG.iterations
    let leftBound = CONFIG.minRpsn
    let rightBound = CONFIG.maxRpsn
    let closestDiff = CONFIG.maxRpsn

    let newLeftBound = 0
    let newRightBound = 0
    let result = 0

    // Perform iterative refinement to find the rate where leftSide ≈ rightSide
    for (let iterations = 0; iterations < CONFIG.iterations; iterations++) {
        let minFound = false

        // Iterate over the current bounds in steps of `jump`
        for (let i = leftBound; i <= rightBound; i += jump) {
            const leftSide = calculateRPSNLeftSide(i, installments)
            const rightSide = calculateRPSNRightSide(i, payments)
            const diff = Math.abs(leftSide - rightSide)

            // Keep the best match (closest diff between both sides)
            if (diff < closestDiff) {
                closestDiff = diff
                newLeftBound = i - jump
                newRightBound = i + jump
                result = i
                minFound = true
            }

            // Optimization: if diff starts getting worse, we can break early
            if (minFound && diff > closestDiff) {
                break
            }
        }

        // Prepare for next iteration with narrowed bounds and smaller jump
        closestDiff = CONFIG.maxRpsn
        leftBound = newLeftBound
        rightBound = newRightBound
        jump /= CONFIG.iterations
    }

    return result * 100 // Result of RPSN/APR in percentage
}
